/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { HTTPValidationError, UpdateStatus200, UpdateStatusBody } from './platformapi.schemas';

import updateStatusMutator from '../custom-axios-instance';

/**
 * API to accept or decline a pending introduction
 * @summary Update Status
 */
export const updateStatus = (updateStatusBody: UpdateStatusBody, signal?: AbortSignal) => {
  return updateStatusMutator<UpdateStatus200>({
    url: `${import.meta.env['VITE_API_HOST']}/introductions/update_status`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateStatusBody,
    signal,
  });
};

export const getUpdateStatusMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStatus>>,
    TError,
    { data: UpdateStatusBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStatus>>,
  TError,
  { data: UpdateStatusBody },
  TContext
> => {
  const mutationKey = ['updateStatus'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStatus>>,
    { data: UpdateStatusBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateStatus>>>;
export type UpdateStatusMutationBody = UpdateStatusBody;
export type UpdateStatusMutationError = void | HTTPValidationError;

/**
 * @summary Update Status
 */
export const useUpdateStatus = <TError = void | HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStatus>>,
    TError,
    { data: UpdateStatusBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStatus>>,
  TError,
  { data: UpdateStatusBody },
  TContext
> => {
  const mutationOptions = getUpdateStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
